// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__buF07","exp":"style_exp__jayyt"};